export default "__VITE_ASSET__6e4077da__"